import CalendarIcon from '@heroicons/react/outline/esm/CalendarIcon.js'

import { CustomFieldViewProps } from '../utils.js'

export const DateView = ({ value }: CustomFieldViewProps) => {
  if (!value) {
    return null
  }

  return (
    <div className="text-content-subdued flex space-s-1 items-center">
      <CalendarIcon className="w-5 h-5" />
      <span suppressHydrationWarning>{value}</span>
    </div>
  )
}
